import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CatalogMobileSelectorService {
  private readonly open$ = new Subject<void>();

  nextOpenSelector(): void {
    this.open$.next();
  }

  getOpenSelector(): Observable<void> {
    return this.open$.asObservable();
  }
}
